/* Wildfang — the standalone "Zur Kasse" button in the product buy box.

   Rendered by snippets/buy-buttons.liquid, and only for the main product page.
   Three jobs, none of them obvious from the markup alone.

   1. LET IT DO A NATIVE SUBMIT.
      product-form.js:21 calls evt.preventDefault() on EVERY submit inside
      <product-form> — unconditionally, before it inspects anything — and then
      POSTs the form itself over fetch. A plain submit button would therefore
      never reach Shopify, and return_to would be dropped along with the rest of
      the native navigation.

      The listener below runs in the CAPTURE phase on document. Capture on an
      ancestor is guaranteed to run before a target-phase listener on the form,
      which is what product-form.js registers, so we get first refusal on the
      event. stopImmediatePropagation() then ends the dispatch outright — it
      never reaches the form — while the default action survives, because we
      deliberately never call preventDefault(). The browser performs its normal
      POST to /cart/add and Shopify honours return_to=/checkout.

      Scoped by evt.submitter, so add-to-cart keeps its AJAX path and its cart
      drawer. Only this one button opts out.

   2. HIDE IT WHILE A SUBSCRIPTION IS SELECTED.
      Subify dispatches on window:

        subify:sellingPlanChange
          detail: { targetProductId, selectedSellingPlan }

      selectedSellingPlan is null for "Einmaliger Kauf" and the plan object for
      a subscription — the SDK sends `choice === ONE_TIME_PURCHASE ? null : plan`
      from a React effect keyed on the plan and the purchase choice, so it fires
      once on mount and again on every toggle.

      A subscription bought through a straight-to-checkout button would never
      show the buyer a cart, so the recurring terms would go by unseen. The
      add-to-cart path stays available for that and is where subscribers belong.

   3. HIDE IT WHEN THE VARIANT IS NOT PURCHASABLE.
      This one is easy to miss. On variant change product-info.js:215-218 calls
      productForm.toggleSubmitButton(), which touches ONLY product-form.js's
      this.submitButton — the add-to-cart. Nothing else in the buy box is
      re-rendered. Left alone our button would stay live on a sold-out variant
      and POST into a Shopify error page.

      product-info.js:220 publishes variantChange immediately AFTER that call,
      so by the time we run the add-to-cart's disabled attribute is already
      correct and we can simply mirror it — same source of truth Dawn uses, no
      second inventory calculation to drift out of sync. We find our button as a
      sibling of the add-to-cart rather than by product id, because the event
      carries a section id.

   VISIBILITY IS THE AND OF (2) AND (3), which is why both live in one state map
   and one apply() rather than each toggling `hidden` directly — two independent
   writers would let whichever fired last win and silently undo the other.

   FALLBACK. (2) assumes the widget loads. If it is blocked or its request
   fails no event ever arrives, and a button rendered hidden by Liquid would
   stay hidden for good. After REVEAL_AFTER_MS we treat any product we have
   heard nothing about as one-time — correct rather than merely safe, because
   without the widget there is no subscription option on the page to guard.
*/

(function () {
  if (window.wfCheckoutButtonReady) return;
  window.wfCheckoutButtonReady = true;

  var BUTTON_SELECTOR = '[data-wf-checkout]';
  var REVEAL_AFTER_MS = 3000;

  // productId -> { subscription: bool, unavailable: bool, answered: bool }
  var state = Object.create(null);

  function stateFor(productId) {
    if (!state[productId]) {
      state[productId] = { subscription: false, unavailable: false, answered: false };
    }
    return state[productId];
  }

  function apply(productId) {
    var current = stateFor(productId);
    var buttons = document.querySelectorAll(BUTTON_SELECTOR);

    for (var i = 0; i < buttons.length; i++) {
      if (buttons[i].getAttribute('data-wf-checkout') !== productId) continue;
      buttons[i].hidden = current.subscription || current.unavailable;
    }
  }

  /* 1. Native submit. */
  document.addEventListener(
    'submit',
    function (event) {
      var submitter = event.submitter;
      if (submitter && submitter.closest && submitter.closest(BUTTON_SELECTOR)) {
        event.stopImmediatePropagation();
      }
    },
    true
  );

  /* 2. Purchase choice. */
  window.addEventListener('subify:sellingPlanChange', function (event) {
    var detail = event.detail || {};
    var productId = String(detail.targetProductId || '');
    if (!productId) return;

    var current = stateFor(productId);
    current.answered = true;
    current.subscription = Boolean(detail.selectedSellingPlan);
    apply(productId);
  });

  /* 3. Variant availability. */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var sectionId = event && event.data && event.data.sectionId;
      if (!sectionId) return;

      var addToCart = document.getElementById('ProductSubmitButton-' + sectionId);
      if (!addToCart || !addToCart.parentElement) return;

      var button = addToCart.parentElement.querySelector(BUTTON_SELECTOR);
      if (!button) return;

      var productId = button.getAttribute('data-wf-checkout');
      stateFor(productId).unavailable = addToCart.hasAttribute('disabled');
      apply(productId);
    });
  }

  /* Fallback for a widget that never loaded. */
  window.setTimeout(function () {
    var buttons = document.querySelectorAll(BUTTON_SELECTOR);

    for (var i = 0; i < buttons.length; i++) {
      var productId = buttons[i].getAttribute('data-wf-checkout');
      if (stateFor(productId).answered) continue;

      stateFor(productId).answered = true;
      apply(productId);
    }
  }, REVEAL_AFTER_MS);
})();
